import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: " How do I find the best mobile app developer company?",
    answer: `<p>Here are the 5 top considerations while picking the best mobile app developer:</p> 
        <ul>
        <li>Qualification and Experience</li>
        <li>References and Portfolio</li>
        <li>App Development Cost</li>
        <li>Communication Process</li>
        <li>Client Focus</li>
    </ul>`,
  },
  {
    question: "How much do app developers charge to make an app?",
    answer: ` <p>App developers charge according to the complexity of the apps they’re developing.</p>
        <p>A simple app with basic functionality such as a flashlight app or a calculator can cost around $10,000 to $40,000 whereas a complex app such as an e-commerce app or a social media app can cost around $30,000 to $500,000 or more.</p>`,
  },
  {
    question: "Is app development still in demand?",
    answer: `<p>Yes, the demand to hire app developers for mobile app development has rolled up multiple times in the last few years and right now it is at an all-time high.</p>`,
  },
  {
    question: "How much does it cost to hire a mobile app developer?",
    answer: `<p>The cost to hire a mobile app developer in the US is around $105,000 per year.</p>
        <p>With this cost, it will cost you around $16,000 to $32,000 to develop an app with basic user interface and a set of basic features.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
